(ns app.components.input-field.views
  (:require [app.components.buttons.views :refer [icon-button]]
            [app.components.icons.views :refer [eye-icon eye-off-icon search-icon]]
            [app.components.input-field.styles :refer [input-field-style
                                                       input-field-xlarge-style
                                                       label-text-field-folder
                                                       label-text-field-style
                                                       untitled-product-form-label
                                                       search-bar-style search-bar-container]]
            [re-com.core :as re-com :refer [at h-box] :rename {input-text inputText}]
            [re-com.input-text :refer [input-password]]
            [re-com.text :refer [label]]
            [app.dashboard.events :as wevents]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]))

(defn input-field [{:keys [placeholder disable value onChange width size change-on-blur? height id  class]}]
  (let [!ref (atom nil)]
    (reagent/create-class
     {:component-did-mount
      (fn [] (reagent/after-render (fn []
                                     (some-> @!ref .focus))))
      :reagent-render
      (fn []
        [inputText
         :src at
         :placeholder placeholder
         :disabled? disable
         :model value
         :width width
         :height height
         :class (if-not (nil? class)
                  class
                  (if (= size :xlarge)
                    (input-field-xlarge-style)
                    (input-field-style)))
         :change-on-blur? change-on-blur?
         :attr {:id id
                :ref (fn [com] (reset! !ref com))}
         :parts {:inner {:attr {:autoFocus true}}}
         :on-change onChange])})))
(defn label-text-field [{:keys [name disable onChange text-val workspace-id id padding selected new-folder? placeholder]}]
  (let [state {:label-clicked? (reagent/atom false) :focused? (reagent/atom false)
               :is-new-folder? (reagent/atom new-folder?)}]
    (fn [{:keys [label-clicked-out? name]}]

      [:div {:id "text-field-id" :class (label-text-field-style padding)
             :on-blur  #(do (reset! (:label-clicked? state) false)
                            (reset! label-clicked-out? false)
                            (when new-folder?
                              (re-posh/dispatch [::wevents/update-folder-new false]))
                            (reset! (:is-new-folder? state) false))
             :on-key-down (fn [^js/Event e]
                            (when (= (-> e .-which) 13) (.. e -target blur))
                            (when (or (= (-> e .-which) 13) (= (-> e .-which) 32))
                              (.stopPropagation e)))}
       (if (or (and selected @(:label-clicked? state)) @label-clicked-out? @(:is-new-folder? state))
         [input-field {:placeholder placeholder
                       :disable disable
                       :value text-val
                       :onChange onChange
                       :workspace-id workspace-id
                       :id id
                       :focused? (or @(:label-clicked? state) @label-clicked-out? @(:is-new-folder? state))
                       :change-on-blur? true
                       :class (label-text-field-folder)
                       :width "100%"}]
         [label :label (if (not= name "") name placeholder)
          :width "239.5px"
          :attr {:on-click #(do (reset! (:label-clicked? state) true)
                                (reset! (:focused? state) true))}
          :class (untitled-product-form-label name)])])))

(defn folder-item-content-editable [{:keys [icon name text-val onChange workspace-id folder-id label-clicked-out? selected new-folder?]}]
  (let [label-clicked? (reagent/atom label-clicked-out?)]
    (fn []
      [h-box :gap "8px"
       :children [(when (some? icon) [icon {:size "24px"}])
                  [label-text-field {:placeholder "Untitled" :disable false :value text-val
                                     :onChange #(do
                                                  (reset! text-val %)
                                                  (onChange @text-val))
                                     :focused? true
                                     :workspace-id workspace-id
                                     :id folder-id
                                     :name name
                                     :padding "none"
                                     :text-val text-val
                                     :width "100px"
                                     :label-clicked-out? @label-clicked?
                                     :new-folder? new-folder?
                                     :selected selected}]]
       :align :center
       :justify :center
       :width "90%"
       :padding "none"])))

(defn password-field [{:keys [placeholder value onChange width size change-on-blur? new-password?]}]
  (let [show-password? (reagent/atom false)]
    (fn []
      [:div
       {:style {:position "relative" :width "100%"}}
       (if @show-password?
         [icon-button {:icon eye-off-icon :onClick #(swap! show-password? not)
                       :style {:position "absolute" :top "50%" :right "12px" :transform "translate3d(0, -50%,0)"}}]
         [icon-button {:icon eye-icon :onClick #(swap! show-password? not)
                       :style {:position "absolute" :top "50%" :right "12px" :transform "translate3d(0, -50%,0)"}}])
       (if @show-password?
         [inputText
          :src at
          :placeholder placeholder
          :model value
          :width width
          :class (if (= size :xlarge)
                   (input-field-xlarge-style)
                   (input-field-style))
          :change-on-blur? change-on-blur?
          :on-change onChange]
         [input-password
          :src at
          :placeholder placeholder
          :model value
          :width width
          :class (if (= size :xlarge)
                   (input-field-xlarge-style)
                   (input-field-style))
          :attr {:id "new-pwd"
                 :autocomplete (if new-password? "new-password" "current-password")}
          :change-on-blur? change-on-blur?
          :on-change onChange])])))

(defn search-bar-field [{:keys [placeholder value onChange width height]}]
  [:div
   {:class (search-bar-container)}
   [icon-button {:icon search-icon
                 :style {:position "absolute" :top "50%" :left "12px" :transform "translate3d(0, -50%,0)"}}]
   [inputText
    :src at
    :placeholder placeholder
    :model value
    :change-on-blur? false
    :width width
    :class (search-bar-style)
    :height height
    :on-change onChange]])